import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Zap } from "lucide-react";

export const FoundersBanner = () => {
  const { user } = useAuth();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/billing/founders-promo").then(({ data }) => setPromo(data)).catch(() => {});
  }, []);

  if (!promo || promo.remaining <= 0) return null;
  if (user && user !== false && (user.role === "seller" || user.role === "admin" || user.role === "staff")) return null;

  return (
    <Link
      to="/register?role=seller"
      data-testid="founders-banner"
      className="block bg-[#FF3B30] text-white text-center text-xs sm:text-sm font-bold uppercase tracking-wider py-2 px-4 hover:bg-[#e0342a] transition-colors"
    >
      <Zap className="inline h-3.5 w-3.5 -mt-0.5 mr-1" strokeWidth={2.5} />
      <span data-testid="founders-banner-count">{promo.remaining} of {promo.cap}</span> founder spots left — first month FREE for sellers. Claim yours →
    </Link>
  );
};
